import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import mergeSx from 'utils/mergeSx';

interface Props {
  /** Styles for the full-bleed band (background, borders) */
  bandSx?: SxProps<Theme>;
  /** Max width of the inner centered container in px */
  maxWidth?: number;
  /** Styles for the inner container (vertical paddings etc.) */
  innerSx?: SxProps<Theme>;
  children: ReactNode;
}

const Section: FC<Props> = ({ bandSx, maxWidth = 1080, innerSx, children }) => (
  <Box sx={bandSx}>
    <Box
      sx={mergeSx({ maxWidth, mx: 'auto', px: { xs: 2.5, md: 4 } }, innerSx)}
    >
      {children}
    </Box>
  </Box>
);

export default Section;
